module.exports = __webpack_public_path__ + "img/pd-img30.da1ff417.png";